<template>
  <LayoutDashboard title="Contatos">
    <v-card outlined>
      <v-card-title>
        <!-- <v-layout row wrap> -->
        <!-- <v-flex xs12 md6> -->
        <v-btn
          outlined
          color="primary"
          class="ma-1"
          @click="cadastrarContato"
          v-if="$helper.verificaPermissao('cadastrar-contato')"
          >Cadastrar</v-btn
        >
        <!-- <v-btn color="success" class="ma-1" @click="$router.push({name: 'produtoImportacao'})">Importar Produtos</v-btn> -->
        <!-- </v-flex> -->
        <v-spacer></v-spacer>
        Contatos: {{ getContatos.total }} -
        <v-pagination
          outlined
          total-visible="7"
          v-model="getContatos.current_page"
          :length="getContatos.last_page"
          @input="visualizarPagina($event)"
        ></v-pagination>

        <!-- <v-flex xs12 md4>
            <span class="float-right title mr-10 ml-1">
              <h5>Página: {{ getContatos.current_page }} de {{ getContatos.last_page }}</h5></span
            >
            <span class="float-right title mr-1 ml-1">
              <h5>Contatos: {{ getContatos.total }} -</h5>
            </span>
          </v-flex>
          <v-flex xs12 md2>
            <v-icon class=" mr-1 ml-1" v-if="getContatos.current_page > 1" @click="visualizarPagina(1)"> mdi-arrow-collapse-left</v-icon>
            <v-icon class=" mr-1 ml-1" v-if="getContatos.current_page > 1" @click="visualizarPagina(getContatos.current_page - 1)">keyboard_arrow_left</v-icon>
            <v-icon class="mr-1 ml-1" v-if="getContatos.current_page < getContatos.last_page" @click="visualizarPagina(getContatos.current_page + 1)">keyboard_arrow_right</v-icon>
            <v-icon class="mr-1 ml-1" v-if="getContatos.current_page < getContatos.last_page" @click="visualizarPagina(getContatos.last_page)">mdi-arrow-collapse-right</v-icon>
          </v-flex>
        </v-layout> -->
      </v-card-title>
      <v-card-title class="py-0 px-5">
        <v-layout row wrap>
          <v-row justify="center"> </v-row>
          <!-- <v-flex xs12 m11>
                        <v-flex xs12 md11>
                            <v-container class="max-width">
                              <v-pagination
                                v-model="getContatos.current_page"
                                class="my-4"
                                :length="getContatos.last_page"
                                @click="visualizarPagina(getContatos.current_page)"
                              ></v-pagination>
                            </v-container>
                          </v-flex>
                    </v-flex> -->
        </v-layout>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th width="10%">
                  <v-text-field
                    v-model="dataPagina.id"
                    outlined
                    dense
                    label="Código"
                    class="mt-2"
                    @input="debouncedPesquisar()"
                    type="number"
                  ></v-text-field>
                </th>
                <th>
                  <v-text-field
                    v-model="dataPagina.nome"
                    outlined
                    dense
                    label="Nome"
                    class="mt-2"
                    @input="debouncedPesquisar()"
                  ></v-text-field>
                </th>
                <th width="12%">
                  <v-text-field
                    v-model="dataPagina.cpf_cnpj"
                    outlined
                    dense
                    label="CPF/CNPJ"
                    class="mt-2"
                    v-mask="['##.###.###/####-##', '###.###.###-##']"
                    @input="debouncedPesquisar()"
                  ></v-text-field>
                </th>
                <th width="12%">
                  <v-select
                    :items="getTiposContatos"
                    v-model="dataPagina.tipo"
                    label="Tipo"
                    outlined
                    dense
                    class="mt-2"
                    @input="debouncedPesquisar()"
                  ></v-select>
                </th>
                <th width="12%">
                  <v-text-field
                    v-model="dataPagina.cidade"
                    outlined
                    dense
                    label="Cidade"
                    class="mt-2"
                    @input="debouncedPesquisar()"
                  ></v-text-field>
                </th>
                <th width="18%">
                  <v-text-field
                    v-model="dataPagina.telefone"
                    outlined
                    dense
                    label="Telefone"
                    class="mt-2"
                    v-mask="'(##) ####-####'"
                    @input="debouncedPesquisar()"
                  ></v-text-field>
                </th>
                <th width="10%">
                  <v-select
                    outlined
                    dense
                    :items="resultadosPorPagina"
                    item-value="value"
                    item-text="label"
                    v-model="limitePorPagina"
                    label="Resultados"
                    @change="visualizarPagina(getContatos.current_page)"
                    class="mt-2"
                  ></v-select>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in getContatos.data" :key="item.id">
                <td align="center">{{ item.id }}</td>
                <td>{{ item.nome }}</td>
                <td width="15%">{{ item.cpf_cnpj }}</td>
                <td>{{ item.tipo }}</td>
                <td>{{ item.cidade }}/{{ item.uf }}</td>
                <td>
                  <span v-if="item.telefone">{{ item.telefone }}</span>
                  <span v-if="item.celular1"> / {{ item.celular1 }}</span>
                </td>
                <td>
                  <TooltipButton
                    @click.native="visualizarContato(item.id)"
                    classButton="ml-2"
                    subtitle="Visualizar"
                    icon="search"
                    color="primary"
                    v-if="$helper.verificaPermissao('visualizar-contato')"
                  />
                  <TooltipButton
                    @click.native="
                      $store.commit('setContato', item),
                        setModalExcluirContato(true)
                    "
                    classButton="ml-2"
                    subtitle="Excluir"
                    icon="clear"
                    color="error"
                    v-if="$helper.verificaPermissao('excluir-contato')"
                  />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions class="px-3">
        <v-spacer></v-spacer>
        <h3>Contatos: {{ getContatos.total }} -</h3>
        <v-pagination
          outlined
          total-visible="7"
          v-model="getContatos.current_page"
          :length="getContatos.last_page"
          @input="visualizarPagina($event)"
        ></v-pagination>
        <!-- <v-layout row wrap> 
        <v-flex xs12 md1>
            <v-select outlined dense class="ml-2" :items="resultadosPorPagina" item-value="value" item-text="label" v-model="limitePorPagina" label="Exibir" @change="visualizarPagina(getContatos.current_page)"></v-select>
          </v-flex>
        <v-flex xs12 md10>
            <span class="float-right title mr-10 ml-1"
              ><h5>Página: {{ getContatos.current_page }} de {{ getContatos.last_page }}</h5></span
            >
            <span class="float-right title mr-1 ml-1"
              ><h5>Contatos: {{ getContatos.total }} -</h5></span
            >
          </v-flex>
          <v-flex xs12 md2>
            <v-icon class=" mr-1 ml-1" v-if="getContatos.current_page > 1" @click="visualizarPagina(1)"> mdi-arrow-collapse-left</v-icon>
            <v-icon class=" mr-1 ml-1" v-if="getContatos.current_page > 1" @click="visualizarPagina(getContatos.current_page - 1)">keyboard_arrow_left</v-icon>
            <v-icon class="mr-1 ml-1" v-if="getContatos.current_page < getContatos.last_page" @click="visualizarPagina(getContatos.current_page + 1)">keyboard_arrow_right</v-icon>
            <v-icon class="mr-1 ml-1" v-if="getContatos.current_page < getContatos.last_page" @click="visualizarPagina(getContatos.last_page)">mdi-arrow-collapse-right</v-icon>
          </v-flex>
        </v-layout> -->
      </v-card-actions>
    </v-card>
    <ModalCadastro />
    <ModalExcluir />
  </LayoutDashboard>
</template>

<script>
import Contato from "@/services/ContatoService";
import ModalCadastro from "@/pages/contato/ModalCadastro";
import ModalExcluir from "@/pages/contato/ModalExcluir";
import { mapGetters, mapActions } from "vuex";
var _ = require("lodash");

export default {
  components: {
    ModalCadastro,
    ModalExcluir,
  },
  data() {
    return {
      limitePorPagina: 20,
      dataPagina: {
        page: 1,
        id: "",
        nome: "",
        tipo: "",
        cpf_cnpj: "",
        cidade: "",
        telefone: "",
        limit: "",
      },
      resultadosPorPagina: [
        {
          label: "10",
          value: 10,
        },
        {
          label: "20",
          value: 20,
        },
        {
          label: "30",
          value: 30,
        },
        {
          label: "40",
          value: 40,
        },
        {
          label: "50",
          value: 50,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["getContatos", "getTiposContatos"]),
  },

  methods: {
    ...mapActions([
      "listarContatos",
      "visualizarContato",
      "cadastrarContato",
      "setModalCadastroContato",
      "visualizarPaginaContato",
      "setModalExcluirContato",
    ]),

    visualizarPagina(pagina) {
      this.dataPagina.page = pagina;
      this.dataPagina.path = this.getContatos.path;
      this.dataPagina.limit = this.limitePorPagina;
      this.listarContatos(this.dataPagina);
    },

    pesquisar() {
      this.dataPagina.pagina = 1;
      this.dataPagina.path = this.getContatos.path;
      this.dataPagina.limit = this.limitePorPagina;
      this.listarContatos(this.dataPagina);
    },
  },
  created() {
    this.dataPagina.limit = this.limitePorPagina;
    this.listarContatos(this.dataPagina);
    this.debouncedPesquisar = _.debounce(this.pesquisar, 300);
  },
};
</script>
